<cm-inspector-section>
    <ng-container cm-content>
        <cm-value-slot
            #inputTypeSelection
            [node]="$inputTypeSelectionDummyNode()"
            [key]="'input'"
            [label]="'Mode'"
            [selectionPossibilities]="$inputTypeSelectionPossibilities()"
            (onChanged)="onInputTypeSelectionChange($event)"
        ></cm-value-slot>
        @if ($attributeSetObjectLikeInput(); as attributeSetObjectLikeInput) {
            @if ($attributeSetPointLikeInput(); as attributeSetPointLikeInput) {
                <cm-value-slot [node]="attributeSetPointLikeInput" [key]="'point'" [label]="'Point'"></cm-value-slot>
            }
            @if ($attributeSetCurveLikeInput(); as attributeSetCurveLikeInput) {
                <cm-value-slot [node]="attributeSetCurveLikeInput" [key]="'curve'" [label]="'Curve'"></cm-value-slot>
            }
            @if ($attributeSetMeshLikeInput(); as attributeSetMeshLikeInput) {
                <cm-value-slot [node]="attributeSetMeshLikeInput" [key]="'mesh'" [label]="'Mesh'"></cm-value-slot>
                <cm-value-slot [node]="attributeSetMeshLikeInput" [key]="'numUVChannels'" [label]="'Number of UV channels'"></cm-value-slot>
            }
        }
        @if ($attributeSetRecordInput(); as attributeSetRecordInput) {
            @for (key of $attributeSetRecordInputKeys(); track key) {
                <div class="cm-attribute-set-item">
                    <div class="cm-attribute-set-item-slot">
                        <cm-value-slot [node]="attributeSetRecordInput" [key]="'record'" [subKey]="[key]" [label]="key"></cm-value-slot>
                    </div>
                    <div class="cm-attribute-set-item-edit-menu">
                        <i [matMenuTriggerFor]="editMenu" matTooltip="Edit" class="far fa-pen">
                            <mat-menu #editMenu>
                                <cm-template-menu>
                                    <cm-template-menu-section>
                                        <ng-container cm-section-title>
                                            <i class="far fa-pen"></i>
                                            Edit
                                        </ng-container>
                                        <ng-container cm-section>
                                            <cm-list-item (click)="renameRecordField(key)">
                                                <ng-container cm-pre-title>
                                                    <i class="far fa-pen"></i>
                                                </ng-container>
                                                <ng-container cm-title> Rename </ng-container>
                                            </cm-list-item>
                                            <cm-list-item class="cm-remove-icon" (click)="deleteRecordField(key)">
                                                <ng-container cm-pre-title><i class="far fa-trash"></i></ng-container>
                                                <ng-container cm-title>Delete</ng-container>
                                            </cm-list-item>
                                        </ng-container>
                                    </cm-template-menu-section>
                                </cm-template-menu>
                            </mat-menu>
                        </i>
                    </div>
                </div>
            }

            <cm-button class="cm-action-button" (click)="addRecordField()">
                <ng-container cm-text> Add </ng-container>
            </cm-button>
            <cm-input-container>
                <ng-container cm-input>
                    <cm-string-input [(value)]="$addRecordFieldKey"></cm-string-input>
                </ng-container>
            </cm-input-container>
        }
    </ng-container>
</cm-inspector-section>
